import "@xyflow/react/dist/style.css";

import { Background, Controls, ReactFlow, type ReactFlowProps } from "@xyflow/react";

import type { RuleEdge } from "../types/edges";
import type { RuleNode } from "../types/nodes";
import { RULE_CANVAS_GRID_SIZE } from "./constants";
import { CanvasContainer, CanvasLayout, CanvasViewport } from "./styled/canvas.styled";

type CanvasProps = ReactFlowProps<RuleNode, RuleEdge> & {
	gridSize?: number;
	hideAttribution?: boolean;
};

const Canvas = ({ gridSize = RULE_CANVAS_GRID_SIZE, hideAttribution = true, ...props }: CanvasProps) => {
	return (
		<CanvasContainer>
			<CanvasLayout>
				<CanvasViewport>
					<ReactFlow<RuleNode, RuleEdge>
						minZoom={0.2}
						maxZoom={1.6}
						defaultViewport={{ x: 0, y: 0, zoom: 0.7 }}
						fitViewOptions={{ padding: 0.25, maxZoom: 0.85, minZoom: 0.4 }}
						{...props}
						proOptions={{ ...props.proOptions, hideAttribution }}
					>
						<Background gap={gridSize} color="rgba(2, 213, 171, 0.20)" size={2.5} />
						<Controls />
					</ReactFlow>
				</CanvasViewport>
			</CanvasLayout>
		</CanvasContainer>
	);
};

export default Canvas;
